var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solid-table"},[_c('el-table',{attrs:{"data":_vm.tableData}},_vm._l((_vm.columns),function(col){return _c('el-table-column',{key:col.prop,attrs:{"prop":col.prop,"label":col.label,"type":col.type},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"normal-cell",class:{
            bolder: scope.row.bolder,
            bold: scope.row.bold,
            indent: ['name', 'index'].includes(scope.column.property)
          }},[_vm._v(" "+_vm._s(scope.row[col.prop])+" ")])]}}],null,true)})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }